module.exports = __webpack_public_path__ + "img/question.e2e812ea.png";